import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingResolutionIncreaserConfig } from '@/data/landingConfig/landingResolutionIncreaserConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ResolutionIncreaser } from './schemaObject';

const ResolutionIncreaser = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ResolutionIncreaser} />
			<LandingTemplate
				data={landingResolutionIncreaserConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageUpscaleV3()}
			/>
		</>
	);
};

export default ResolutionIncreaser;
